var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SliderRow", {
    attrs: {
      id: _vm.id,
      label: _vm.$t(_vm.fieldConfig.label),
      value: _vm.fieldValue,
    },
    on: {
      "update:value": [
        function ($event) {
          _vm.fieldValue = $event
        },
        _vm.syncChange,
      ],
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }